import { render, staticRenderFns } from "./login-menu.vue?vue&type=template&id=71820706&scoped=true"
import script from "./login-menu.vue?vue&type=script&lang=js"
export * from "./login-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71820706",
  null
  
)

export default component.exports